import React, { useState } from 'react';
import TableWithPagination from '../common/TableWithPagination';
import { toast } from 'react-toastify';
import Modal from '../common/Modal';
import dayjs from 'dayjs';
import { useApi } from './../../hooks/useApi';

const DetalleLogPanel = ({ log, detalle, loading, onClose }) => {
  const { get, post } = useApi();

  const [popoverDetalle, setPopoverDetalle] = useState({});
  const [popoverLoading, setPopoverLoading] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSalesOrder, setModalSalesOrder] = useState(null);
  const [erroresGeneral, setErroresGeneral] = useState(null);

  const getStatusConfig = (status) => {
      if (!status) {
        return {
          label: 'PD',
          className: 'bg-gray-200 text-gray-800'
        };
      }

      switch (status) {
        case 'ER':
          return {
            label: 'ER',
            className: 'bg-red-200 text-red-800'
          };
        case 'PR':
          return {
            label: 'PR',
            className: 'bg-yellow-200 text-yellow-800'
          };
        default:
          return {
            label: status,
            className: 'bg-gray-200 text-gray-800'
          };
      }
    };

  const formatDate = (date) =>
    date ? dayjs(date).format('DD/MM/YYYY') : '';

  if (!log) return null;
  const clienteInfo =
    popoverDetalle[modalSalesOrder]?.[0]
      ? `${popoverDetalle[modalSalesOrder][0].clientId} | ${popoverDetalle[modalSalesOrder][0].clientName}`
      : '';

  const fetchDetalle = async (row) => {
    const salesOrder = row.salesOrder;

    // cache
    if (popoverDetalle[salesOrder]) return;

    setPopoverLoading((prev) => ({ ...prev, [salesOrder]: true }));
    try {
      const params = {
        salesOrder,
        pipeLineExecutionId: row.pipeLineExecutionId,
        fileName: row.fileName,
        businessId: row.businessId,
      };

      const response = await get('detalleTraduccion', { params });
      console.log('Detalle respuesta:', response);
      setPopoverDetalle((prev) => ({ ...prev, [salesOrder]: response.detalles || [] }));
      setErroresGeneral((prev) => ({ ...prev, [salesOrder]: response.infoGral || [] }));
    } catch (error) {
      setPopoverDetalle((prev) => ({ ...prev, [salesOrder]: [] }));
    } finally {
      setPopoverLoading((prev) => ({ ...prev, [salesOrder]: false }));
    }
  };

  const reprocesarFile = async () => {
    await post('reprocesarArchivo', {
      fileName: log.fileName,
      customerName: log.customerName
    });
    toast.success('Reproceso finalizado.');
};






  return (
    <div className="w-full bg-white shadow-lg rounded-lg p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-l font-semibold text-gray-800 flex items-center gap-2">
          <span>📄</span> Archivo {log.fileName}
        </h3>

        <span
          className={`px-3 py-1 rounded-full text-sm font-semibold ${
            log.orderStatusFinal === 'PR'
              ? 'bg-green-100 text-green-800'
              : log.orderStatusFinal === 'PE'
              ? 'bg-yellow-100 text-yellow-800'
              : 'bg-gray-100 text-gray-800'
          }`}
        >
          {log.orderStatusFinal || 'N/A'}
        </span>
        <div className='flex gap-2'>
          <button
            onClick={reprocesarFile}
            className="bg-red-500 text-white px-3 py-1 rounded"
          >
            Reprocesar
          </button>
          <button
            onClick={onClose}
            className="bg-gray-500 text-white px-3 py-1 rounded"
          >
            Cerrar
          </button>
        </div>

      </div>

      {/* Contenido */}
      {loading ? (
        <p className="text-gray-500 italic">Cargando detalle...</p>
      ) : detalle ? (
        <div className="mt-4 w-full overflow-x-auto">
          <TableWithPagination
            columns={[
              { header: 'Orden de compra', accessor: 'salesOrder' },
              { header: 'Cliente', accessor: 'businessId' },
              { header: 'Líneas', accessor: 'linea' },
              {
                header: 'Cantidad',
                accessor: 'qty',
                Cell: ({ value }) => (
                  <div className="text-right">
                    {Number(value).toLocaleString('es-MX', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                ),
              },
              {
                header: 'Estatus',
                accessor: 'orderStatus',
                Cell: ({ value }) => {
                  const { label, className } = getStatusConfig(value);

                  return (
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-semibold ${className}`}
                    >
                      {label}
                    </span>
                  );
                }
              },
              {
                header: 'Acciones',
                accessor: 'acciones',
                Cell: ({ row }) => (
                  <button
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    onClick={() => {
                      fetchDetalle(row);
                      setModalSalesOrder(row.salesOrder);
                      setModalOpen(true);
                    }}
                  >
                    Ver detalle
                  </button>
                ),
              },
            ]}
            data={detalle || []}
            showView={false}
            showEdit={false}
            showDelete={false}
            loading={false}
          />
        </div>
      ) : (
        <p className="text-gray-500 italic">
          No se encontró información del detalle.
        </p>
      )}

      {/* Modal Detalle */}
      <Modal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        title={`Orden ${modalSalesOrder}${
          clienteInfo ? ` - Cliente: ${clienteInfo}` : ''
        }`}
        size="full"
      >
        {popoverLoading[modalSalesOrder] ? (
          <p>Cargando...</p>
        ) : (
          <>
          <table className="min-w-full text-xs mb-4">
              {erroresGeneral?.[modalSalesOrder]?.length > 0 ? (
                erroresGeneral[modalSalesOrder].map((error, index) => (
                  <tr key={index} className="bg-red-100">
                    <td className="border p-1 text-red-800">
                      {error.erroresEjecucion}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border p-2 text-center">
                    Sin errores generales
                  </td>
                </tr>
              )}
          </table>

          <table className="min-w-full text-xs">
            <thead className="bg-slate-100 text-slate-600 uppercase text-xs text-center">
              <tr>
                <th className="border">Lín.</th>
                <th className="border">Prod.</th>
                <th className="border">Nom.</th>
                <th className="border">UM Orig.</th>
                <th className="border text-right">Cant. Orig.</th>
                <th className="border">UM</th>
                <th className="border text-right">Cant.</th>
                <th className="border text-right">Precio</th>
                <th className="border text-right">Total</th>
                <th className="border">Validaciones</th>
              </tr>
            </thead>

            <tbody>
              {popoverDetalle[modalSalesOrder]?.map((item, index) => (
                <tr key={index}>
                  <td className="border text-center">{item.lineNumber}</td>
                  <td className="border px-1">{item.product}</td>
                  <td className="border px-1">{item.productQa}-{item.name}</td>
                  <td className="border text-center">{item.measureUnit}</td>
                  <td className="border text-right">
                    {Number(item.quantity).toLocaleString('es-MX', {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td className="px-1 border text-center">{item.measureUnit}</td>
                  <td className="px-1 border text-right">
                    {Number(item.originalQuantity).toLocaleString('es-MX', {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td className="px-1 border text-right">
                    {Number(item.UnitPrice).toLocaleString('es-MX', {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td className="px-1 border text-right">
                    {Number(item.total).toLocaleString('es-MX', {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td className="border whitespace-pre-line">
                    {item.validationTypes}
                  </td>

                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="font-bold bg-gray-100">
                <td className="border" colSpan={2}>Totales</td>
                <td className="border text-right">
                  {new Set(popoverDetalle[modalSalesOrder]?.map(item => item.lineNumber)).size || 0}
                </td>
                <td className="border"></td>
                <td className="border text-right">
                  {popoverDetalle[modalSalesOrder]?.reduce((sum, item) => sum + Number(item.quantity), 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="border"></td>
                <td className="border text-right">
                  {popoverDetalle[modalSalesOrder]?.reduce((sum, item) => sum + Number(item.originalQuantity), 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="border"></td>
                <td className="border text-right">
                  {popoverDetalle[modalSalesOrder]?.reduce((sum, item) => sum + Number(item.total), 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="border"></td>
              </tr>
            </tfoot>
          </table>
          </>
        )}
      </Modal>
    </div>
  );
};

export default DetalleLogPanel;
